import React, { useEffect, useState} from 'react';
import { TableRow, TableCell, Paper } from '@mui/material';

import Table from '../../../components/Table';

import { TableResponse } from '../../../schema/helper';
import { api } from '../../../api';
import { formatDate } from '../../../util';
import dayjs from 'dayjs';

interface InOut {
  person_id: number;

  company_id: number;
  status_id: number;
  person_type_id: number;
  gate_id?: number;
  area_id?: number;

  personal_id: string;
  name: string;
  person_type: string;

  photo?: string;
  company: string;
  status: string;
  gate: string;
  area?: string;
  created_time: string;
  created_by: string;
}
interface TableInOutProps {
  filterID: string;
  filterName: string;
  filterCompanyIDList: number[];
  filterPersonTypeIDList: string[];
  filterScanTypes: string;
  filterStartDate: Date | null;
  filterEndDate: Date | null;
}
const tableHead = [
  'เลขประจำตัวประชาชน',
  'ชื่อ นามสกุล',
  'ประเภทบุคคล',
  'บริษัท',
  'เวลา',
  'พื้นที่',
  'เข้าออก',
  'ผู้ทำรายการ'
];
const TableInOut: React.FC<TableInOutProps> = ({
  filterID,
  filterName,
  filterCompanyIDList,
  filterPersonTypeIDList,
  filterScanTypes,
  filterStartDate,
  filterEndDate
}: TableInOutProps) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState<TableResponse<InOut> | null>(null);

  const handlePageChange = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      const searchParams = new URLSearchParams();

      if (filterID) {
        searchParams.set('personal_id', filterID);
      }
      if (filterName) {
        searchParams.set('name', filterName);
      }
      if (filterCompanyIDList.length) {
        filterCompanyIDList.forEach((company_id) => {
          searchParams.append('company_id', `${company_id}`);
        });
      }
      if (filterPersonTypeIDList.length) {
        filterPersonTypeIDList.forEach((person_type_id) => {
          searchParams.append('person_type_id', `${person_type_id}`);
        });
      }
      if (filterScanTypes) {
        searchParams.set('type_id', filterScanTypes);
      }
      if (filterStartDate) {
        searchParams.set('start_date', `${formatDate(filterStartDate)}`);
      }
      if (filterEndDate) {
        searchParams.set('end_date', `${formatDate(filterEndDate)}`);
      }
      
      searchParams.set('offset', `${page * rowsPerPage}`);
      searchParams.set('limit', `${rowsPerPage}`);
      api
        .get<TableResponse<InOut>>(`/in-out/table`, {
          params: searchParams
        })
        .then((res) => {
          const { data } = res;
          setData(data);
        });
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [
    filterID,
    filterName,
    filterCompanyIDList,
    filterPersonTypeIDList,
    filterScanTypes,
    filterStartDate,
    filterEndDate,
    page,
    rowsPerPage
  ]);

  return (
    <Paper>
      <Table
        heads={tableHead}
        count={data?.total ? data?.total : 0}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      >
        {data?.data.map((data, index) => (
          <TableRow key={index}>
            <TableCell align="center">{data.personal_id}</TableCell>
            <TableCell align="center">{data.name}</TableCell>
            <TableCell align="center">{data.person_type}</TableCell>
            <TableCell align="center">{data.company}</TableCell>
            <TableCell align="center">{dayjs(data.created_time).format('DD/MM/YYYY | HH:mm:ss')}</TableCell>
            <TableCell align="center">{data.area}</TableCell>
            <TableCell align="center">{data.status}</TableCell>
            <TableCell align="center">{data.created_by}</TableCell>
          </TableRow>
        ))}
      </Table>
    </Paper>
  );
};

export default TableInOut;
